import React from "react";
import { Table } from "react-bootstrap";
import './budgeclaimstab.css'

const Budgeclaimstab: React.FC = () => {
    return (
        <>
            <div className="mby_24">
                <div className="top top_bar_flx mby_16">
                    <div className="top_bar_tittle">
                        <h2>Recent Claims</h2>
                    </div>
                </div>
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Claim ID</th>
                            <th>Participant</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Submitted</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CLM-2025-001</td>
                            <td>John D.</td>
                            <td>$1,200</td>
                            <td style={{ color: "green" }}>Paid</td>
                            <td>09/05/2025</td>
                        </tr>
                        <tr>
                            <td>CLM-2025-002</td>
                            <td>Sarah M.</td>
                            <td>$980</td>
                            <td style={{ color: "red" }}>Denied</td>
                            <td>09/05/2025</td>
                        </tr>
                        <tr>
                            <td>CLM-2025-003</td>
                            <td>Alex B.</td>
                            <td>$2,300</td>
                            <td style={{ color: "orange" }}>Pending</td>
                            <td>09/05/2025</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
            <div>
                <div className="top top_bar_flx mby_16">
                    <div className="top_bar_tittle">
                        <h2>Top Denial Codes</h2>
                    </div>
                </div>
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Reason</th>
                            <th>Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CO-16</td>
                            <td>Claim lacks information</td>
                            <td>12</td>
                        </tr>
                        <tr>
                            <td>CO-18</td>
                            <td>Duplicate claim</td>
                            <td>8</td>
                        </tr>
                        <tr>
                            <td>CO-22</td>
                            <td>Service not covered</td>
                            <td>5</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default Budgeclaimstab;
